import { websocketConnectionRoutes } from './websocket-connection'

export const routes = {
  ...websocketConnectionRoutes,
}
